<template>
  <div>
    <div class="box-detalhe" v-if="prestador && !mapDetalheConfig.open && !loading">
      <el-row class="func-4-item vertical-align" style="padding-top:0; padding-left: 0; padding-bottom: 0">
        <el-col :span="18">
          <h2 class="func-4-title-header title-detalhe">{{ prestador.nome_prestador }}</h2>
        </el-col>
        <el-col :span="6" class="text-right">
          <el-button type="text" class="item-button" :style="`color: ${estilo.aplicacao.corPrimariaAplicacao};`"
                     @click="close">
            <div class="text-side-button">
              <span class="text-button">
                Fechar
              </span>
            </div>
          </el-button>
        </el-col>
      </el-row>

      <Func4Acreditacao :acreditacoes="prestador.acreditacoes" />

      <el-row class="func-4-item" style="padding-left: 0; padding-top:0">
        <el-col :span="24">
          <span style="margin-bottom: 15px;font-size: 14px;">{{ tamanhoTextoEspecialidade(prestador.especialidade) }}</span>
          <el-button
            v-if="especialidadesTextoGrande"
            :style="`color: ${estilo.aplicacao.corPrimariaAplicacao};`"
            type="text"
            @click.prevent="openEspecialidades()"
          >{{ this.activeNames[0] ? 'Ver menos' : 'Ver mais' }}
          </el-button>
        </el-col>
        <el-col v-if="prestador.subespec" :span="24">
          <span style="margin-bottom: 15px;font-size: 14px;">{{ tamanhoTextoSubespecialidade(prestador.subespec) }}</span>
        </el-col>
      </el-row>

      <el-row class="func-4-item" style="padding-left: 0; padding-top:0">
        <el-col :span="12">
          <el-button v-if="locations.coordenadas" plain class="btn-detalhe-mapa" @click="mapDetalheConfig.open = true">
            <i class="el-icon-full-screen button-icon-map" />
          </el-button>
          <Mapa
            v-if="hasLocation"
            v-show="mapConfig.open"
            :locations="locations"
            :config="mapConfig"
            :pin-color="esquemaDeCor.aplicacao.corPrimariaAplicacao"
          />
          <div
            v-else
            style="height: 180px; display: flex; flex-flow: column; justify-content: center; align-items: center; color: white; background-color: lightgray; font-size: large; border-radius: 8px;"
          >
            <i class="el-icon-map-location"/>
            Sem localização
          </div>
        </el-col>
        <el-col :span="12">
          <el-row class="func-4-item" style="padding-top:0">
            <el-col :span="2">
              <svgIcone icone="icon_mini_map" :width="15" :height="15" style="opacity: 0.2;"></svgIcone>
            </el-col>
            <el-col :span="22">
              <span>
                {{ prestador.endereco }}, {{ prestador.numero }}{{ (prestador.complemento==="") ? '': `, ${prestador.complemento}`}} <br />
                {{ prestador.bairro }} - {{ prestador.nome_cidade }}, {{ prestador.nome_estado }}
              </span>
            </el-col>
          </el-row>
          <el-row class="func-4-item" style="padding-top:0">
            <el-col :span="2">
              <svgIcone icone="icon_mini_phone" :width="15" :height="15" style="opacity: 0.2;"></svgIcone>
            </el-col>
            <el-col :span="22">
              <span>
                {{ prestador.telefone_primario }}<br />
                {{ prestador.telefone_secundario }}
              </span>
            </el-col>
          </el-row>
          <el-row class="func-4-item" style="padding-top:0" v-if="prestador.email && prestador.email != ' '">
            <el-col :span="2">
              <svgIcone icone="icon_mini_email" :width="15" :height="15" style="opacity: 0.2;"></svgIcone>
            </el-col>
            <el-col :span="22">
              <span>
                <a :href="`mailto:${ prestador.email }`" target="_blank"
                   :style="`color: ${estilo.aplicacao.corPrimariaAplicacao};`">
                  {{ prestador.email }}
                </a>
              </span>
            </el-col>
          </el-row>
          <el-row class="func-4-item" style="padding-top:0" v-if="prestador.site_url && prestador.site_url != ' '">
            <el-col :span="2">
              <svgIcone icone="icon_mini_open_new" :width="15" :height="15" style="opacity: 0.2;"></svgIcone>
            </el-col>
            <el-col :span="22">
              <span>
                <a :href="ensureProtocol(prestador.site_url)" target="_blank"
                   :style="`color: ${estilo.aplicacao.corPrimariaAplicacao};`">
                  {{ prestador.site_url }}
                </a>
              </span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row type="flex" class="func-4-item m-top" style="padding-left: 0;" justify="center">
        <el-col v-if="isWidget" :span="5" class="text-center icon-button-box-detalhe">
          <AcoesRedeCredenciada :row="prestador">
            <el-row>
              <inline-svg :fill="corPrimariaAplicacao" style="margin-bottom: 6px; margin-top: 7px" :src="require('@/assets/icons/Dash_utilitarios3.svg')"></inline-svg>
            </el-row>
            <el-row>
                <span style="font-family: Arial; font-size: 11px; font-weight: 600;">AÇÕES</span>
            </el-row>
          </AcoesRedeCredenciada>
        </el-col>
        <el-col v-if="!isWidget && funcParametros.visualizarRotas" :span="5" class="text-center icon-button-box-detalhe">
          <el-button
            type="text"
            class="item-button"
            @click="openRoute()"
            :disabled="!hasLocation"
            :style="hasLocation ? '' : 'color: gray'"
          >
            <el-row>
              <inline-svg
                :fill="hasLocation ? corPrimariaAplicacao : 'gray'"
                style="margin-bottom: 7px" :src="require('@/assets/icons/Dash_route.svg')"
              />
            </el-row>
            <el-row>
              Rotas
            </el-row>
          </el-button>
        </el-col>
        <el-col v-if="funcParametros.visualizarSalvar" :span="5" class="text-center icon-button-box-detalhe">
          <el-button type="text" class="item-button" @click="print">
            <el-row>
              <i v-if="loadingPrint" class="el-icon-loading button-icon" />
              <inline-svg :fill="corPrimariaAplicacao" style="margin-bottom: 7px" :src="require('@/assets/icons/Dash_print.svg')"></inline-svg>
            </el-row>
            <el-row>
              Imprimir
            </el-row>
          </el-button>
        </el-col>
        <el-col :span="5" class="text-center icon-button-box-detalhe">
          <el-button type="text" class="item-button" @click="share()">
            <el-row>
              <inline-svg :fill="corPrimariaAplicacao" style="margin-bottom: 7px" :src="require('@/assets/icons/Dash_share.svg')"></inline-svg>
            </el-row>
            <el-row>
              Compartilhar
            </el-row>
          </el-button>
        </el-col>
        <el-col v-if="!isWidget && funcParametros.visualizarCorrigir" :span="5" class="text-center icon-button-box-detalhe">
          <el-button type="text" class="item-button" @click="openCorrigir">
            <el-row>
              <inline-svg :fill="corPrimariaAplicacao" style="margin-bottom: 7px" :src="require('@/assets/icons/Dash_report_error.svg')"></inline-svg>
            </el-row>
            <el-row>
              {{ funcParametros.textos.labelBotaoCorrigir }}
            </el-row>
          </el-button>
        </el-col>
      </el-row>

      <Func4DetalheAlerta :alert="prestador.mensagem_alerta" />

      <el-row class="func-4-item" style="padding-left: 0;">
        <el-collapse
          class="func-listagens"
          :accordion="true"
          @change="openCollapseItem"
        >
          <el-collapse-item
            class="func-4-li"
            style="margin-top: 0; cursor:pointer"
            name="horariosAtendimento"
            v-if="funcParametros.visualizarHorarioAtendimento"
          >
            <template slot="title" class="func-4-item">
              <el-col :span="24">
                <h2 class="func-4-title" style="margin-left: 10px">
                  {{ funcParametros.textos.labelBotaoHorarioAtendimento }}</h2>
              </el-col>
            </template>

            <el-row class="func-4-item" v-if="horariosAtendimento && horariosAtendimento.length > 0">
              <el-col
                v-for="(horario, index) in horariosAtendimento"
                :key="index"
                :span="12"
                :style="index % 2 !== 0 ? `padding: 15px 0 15px 25px;` : 'padding: 15px 0;'"
              >
                <div style="font-size:14px; margin-bottom: 5px;">
                  <span class="label-mais-detalhes">{{ horario.titulo_horario }}</span><br />
                </div>
                <div>
                  <span class="item-mais-detalhes">
                    {{ horario.horario_inicial }} às {{ horario.horario_final }}
                  </span>
                </div>
              </el-col>
            </el-row>

            <el-row style="padding: 35px 15px"
                    v-else-if="horariosAtendimento.length === 0 && !this.loadingCollapseItem">
              <el-col :span="24">
                <span class="sub">Nenhum resultado encontrado.</span>
              </el-col>
            </el-row>

            <el-row v-if="loadingCollapseItem" class="func-4-item" style="padding-bottom: 0; min-height: 120px">
              <el-col :span="24" style="padding:20px">
                <Loading :loading="loadingCollapseItem" />
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item
            class="func-4-li"
            style="margin-top: 0; cursor:pointer"
            name="equipeMedica"
            v-if="funcParametros.visualizarEquipeMedica"
          >
            <template slot="title" class="func-4-item">
              <el-col :span="22">
                <h2 class="func-4-title" style="margin-left: 10px">
                  {{ funcParametros.textos.labelBotaoEquipeMedica }}</h2>
              </el-col>
            </template>

            <el-row class="func-4-item" v-if="equipeMedica && equipeMedica.length > 0">
              <el-col
                v-for="(equipe, index) in equipeMedica"
                :key="index"
                :span="12"
                :style="index % 2 !== 0 ? `padding: 15px 0 15px 25px;` : 'padding: 15px 0;'"
              >
                <div style="font-size:14px; margin-bottom: 5px;"><span><b>{{ equipe.descricao }}</b></span><br /></div>
                <div>
                  <span>{{ equipe.nome_corpo_clinico }}</span>
                </div>
                <div>
                  <span>{{ equipe.sigla_conselho_regional }} - {{ equipe.numero_conselho_regional }}</span>
                </div>
              </el-col>
            </el-row>

            <el-row style="padding: 35px 15px" v-else-if="equipeMedica.length === 0 && !this.loadingCollapseItem">
              <el-col :span="24">
                <span class="sub">Corpo clínico não encontrado.</span>
              </el-col>
            </el-row>

            <el-row v-if="loadingCollapseItem" class="func-4-item" style="padding-bottom: 0; min-height: 120px">
              <el-col :span="24">
                <Loading :loading="loadingCollapseItem" />
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item
            v-if="funcParametros.visualizarPlanosAtendidos"
            class="func-4-li"
            style="margin-top: 0; cursor:pointer"
            name="planosAtendidos"
          >
            <template slot="title" class="func-4-item">
              <el-col :span="22">
                <h2 class="func-4-title" style="margin-left: 10px">
                  {{ funcParametros.textos.labelBotaoPlanosAtendidos }}</h2>
              </el-col>
            </template>

            <el-row class="func-4-item" v-if="planos && planos.length > 0">
              <el-col
                v-for="(plano, index) in planos"
                :key="index"
                :span="12"
                :style="index % 2 !== 0 ? `padding: 15px 0 15px 25px;` : 'padding: 15px 0;'"
              >
                <div style="font-size:14px; margin-bottom: 5px;"><span><b>{{ plano.descricao }}</b></span><br /></div>
                <div>
                  <span>
                     Nº ANS: {{ plano.registro_plano_ANS }} - {{ plano.classificacao_fins_comercializacao }}<br />
                     {{ plano.situacao_plano_comercializacao }}
                   </span>
                </div>
              </el-col>
            </el-row>

            <el-row style="padding: 35px 15px" v-else-if="planos.length === 0 && !this.loadingCollapseItem">
              <el-col :span="24">
                <span class="sub">Planos não encontrados.</span>
              </el-col>
            </el-row>

            <el-row v-if="loadingCollapseItem" class="func-4-item" style="padding-bottom: 0; min-height: 120px">
              <el-col :span="24">
                <Loading :loading="loadingCollapseItem" />
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item
            class="func-4-li"
            style="margin-top: 0; cursor:pointer"
            name="especialidades"
            accordion
            v-if="funcParametros.visualizarEspecialidades"
          >
            <template slot="title" class="func-4-item">
              <el-col :span="22">
                <h2 class="func-4-title" style="margin-left: 10px">
                  {{ funcParametros.textos.labelBotaoEspecialidades }}</h2>
              </el-col>
            </template>

            <ul class="func-listagens" v-if="especialidades && especialidades.length > 0">
              <li
                v-for="(especialidade, index) in especialidades"
                :key="index"
                class="func-4-li"
              >
                <el-row class="func-4-item">
                  <el-col :span="12">
                   <span>
                     {{ especialidade.endereco }}, {{ especialidade.numero }}, {{ especialidade.complemento }}
                      - {{ especialidade.bairro }}, {{ especialidade.cidade }}, {{ especialidade.estado }}
                   </span>
                  </el-col>
                  <el-col :span="12" class="text-center">
                    <span>
                      <b>{{ especialidade.descricao }}</b>
                   </span>
                  </el-col>
                </el-row>
              </li>
            </ul>

            <el-row style="padding: 35px 15px" v-else-if="especialidades.length === 0 && !this.loadingCollapseItem">
              <el-col :span="24">
                <span class="sub">Especialidades não encontradas.</span>
              </el-col>
            </el-row>

            <el-row v-if="loadingCollapseItem" class="func-4-item" style="padding-bottom: 0; min-height: 120px">
              <el-col :span="24">
                <Loading :loading="loadingCollapseItem" style="padding-top:20px" />
              </el-col>
            </el-row>
          </el-collapse-item>

          <el-collapse-item
            class="func-4-li"
            style="margin-top: 0; cursor:pointer"
            name="maisDetalhes"
            v-if="funcParametros.visualizarMaisDetalhes"
          >
            <template slot="title" class="func-4-item">
              <el-col :span="22">
                <h2 class="func-4-title" style="margin-left: 10px">
                  {{ funcParametros.textos.labelBotaoMaisDetalhes }}</h2>
              </el-col>
            </template>

            <el-row>
              <el-col :span="24" class="func-4-item">
                <span class="label-mais-detalhes">Nome fantasia</span><br>
                <span class="item-mais-detalhes">{{ __informedValue(prestador.nome_prestador) }}</span>
              </el-col>
              <el-col :span="24" class="func-4-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Razão Social</span><br>
                <span class="item-mais-detalhes">{{ __informedValue(prestador.razao_social) }}</span>
              </el-col>
              <el-col :span="24" class="func-4-item" style="padding-top: 0" v-if="prestador.apresenta_cpf === 'S'">
                <span class="label-mais-detalhes">CPF ou CNPJ</span><br>
                <span class="item-mais-detalhes">{{ __informedValue(prestador.cpf_cnpj) }}</span>
              </el-col>
              <el-col :span="24" class="func-4-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Responsável Técnico</span><br>
                <span class="item-mais-detalhes">{{ __informedValue(prestador.nome_responsavel_tecnico) }}</span>
              </el-col>
              <el-col :span="24" class="func-4-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Conselho Regional {{ prestador.sigla_conselho_regional }}</span><br>
                <span class="item-mais-detalhes">{{ prestador.sigla_conselho_regional }} - {{ prestador.numero_conselho_regional }}</span>
              </el-col>
              <el-col :span="24" class="func-4-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Acessibilidade</span><br>
                <span class="item-mais-detalhes">{{ __getValueBoolean(prestador.acessibilidade) }}</span>
              </el-col>
              <el-col :span="24" class="func-4-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Atendimento 24 horas</span><br>
                <span class="item-mais-detalhes">{{ __getValueBoolean(prestador.atend_24_horas) }}</span>
              </el-col>
              <el-col :span="24" class="func-4-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Regime de atendimento</span><br>
                <span class="item-mais-detalhes">{{ __informedValue(prestador.regime_atendimento) }}</span>
              </el-col>
              <el-col :span="24" class="func-4-item" style="padding-top: 0">
                <span class="label-mais-detalhes">{{ funcParametros.textos.labelBotaoSelecaoTipoPrestador }}</span><br>
                <span class="item-mais-detalhes">{{ __informedValue(prestador.tipo_prestador) }}</span>
              </el-col>
              <el-col :span="24" class="func-4-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Tipo de Estabelecimento</span><br>
                <span class="item-mais-detalhes">{{ __informedValue(prestador.tipo_estabelecimento) }}</span>
              </el-col>
              <el-col :span="24" class="func-4-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Observações</span><br>
                <span class="item-mais-detalhes">{{ __informedValue(prestador.observacoes) }}</span>
              </el-col>
            </el-row>
          </el-collapse-item>

        </el-collapse>
      </el-row>
    </div>
    <Func4DetalheMapa :prestador="prestador" :locations="locations" :config="mapDetalheConfig" />
    <Func4Share v-if="showShare" @onCloseClick="showShare = false" />
    <Func4Corrigir v-if="showCorrigir" :custom-voltar="closeCorrigir" :custom-finalizar="finalizarCorrigir"
                   :custom-cancelar="closeCorrigir" />
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'

import Func4DetalheMapa from '@/views/4/DetalheMapa'
import Mapa from '@/components/mapa/Mapa'
import Loading from '@/components/common/Loading'
import { applyTextFormat } from '@/utils/formatTexto'
import Func4DetalheAlerta from '@/views/4/DetalheAlerta'
import Func4Share from '@/views/4/Share'
import Func4Corrigir from '@/views/4/Corrigir'
import Func4Acreditacao from '@/views/4/Acreditacao'
import InlineSvg from 'vue-inline-svg'
import AcoesRedeCredenciada from '@/views/4/AcoesRedeCredenciada.vue'
import { detalheRedeCredenciada } from '@/views/4/RegrasDeNegocio4'
export default {
  name: 'Func4Detalhe',
  components: {
    AcoesRedeCredenciada,
    Func4Acreditacao,
    Func4Corrigir,
    Func4DetalheAlerta,
    Func4Share,
    Func4DetalheMapa,
    Mapa,
    InlineSvg,
    Loading
  },
  data () {
    return {
      equipeMedica: [],
      especialidades: [],
      horariosAtendimento: [],
      loading: false,
      loadingCollapseItem: false,
      loadingPrint: false,
      locations: [],
      openMap: false,
      openMapDetalhe: false,
      planos: [],
      showShare: false,
      showCorrigir: false,
      mapConfig: {
        open: false,
        showHeader: false,
        showCardInfo: false,
        showActions: false,
        height: '180px',
        zoom: 15,
        fullscreenControl: false
      },
      mapDetalheConfig: {
        open: false,
        showHeader: true,
        showCardInfo: true,
        showActions: false,
        height: '634px',
        zoom: 15
      },
      activeNames: [],
      especialidadesTextoGrande: false,
      subespecialidadesTextoGrande: false,
      especialidadesDefault: null
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade', 'esquemaDeCor']),
    ...mapGetters('SetupApp', ['estilo', 'aplicacao', 'configuracaoAcesso', 'isWidget']),
    ...mapGetters('Login', ['token', 'user', 'contratos', 'beneficiarios', 'isLogin']),
    ...mapGetters('RedeCredenciada', ['redeCredenciada', 'showDetalhe', 'prestador', 'idPlano']),
    clientKey () {
      return this.user && this.user.selectedClient && this.user.selectedClient.clientKey
    },
    estiloLinha () {
      return `background: ${this.estilo.aplicacao.corPrimariaAplicacao}0d !important`
    },
    corPrimariaAplicacao () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    funcParametros () {
      return this.funcionalidade.parametros
    },
    hasLocation () {
      return this.locations && this.locations.length > 0
    },
    __informedValue () {
      return (text) => {
        return text && text !== ' ' ? text : 'Não informado'
      }
    },
    __getValueBoolean () {
      return (value) => {
        if (!value) {
          return 'Não informado'
        }
        return value === 'S' ? 'Sim' : 'Não'
      }
    }
  },
  methods: {
    ...mapActions('RedeCredenciada', [
      'setViewDetalhe',
      'setPrestador',
      'setPrintType',
      'setViewPrint',
      'setPrestadorPlanos',
      'setPrestadorEspecialidades',
      'setPrestadorHorarios',
      'setPrestadorEquipeMedica'
    ]),
    closeCorrigir () {
      this.showCorrigir = false
      this.$router.push({ query: null })
    },
    openCorrigir () {
      this.showCorrigir = true
    },
    finalizarCorrigir () {
      this.closeCorrigir()
      this.$notify[('success')]({
        title: 'Sucesso!',
        message: 'Salvo com sucesso.',
        position: 'top-right',
        duration: 2000
      })
    },
    formatTextosPrestador (prestador, formatType) {
      try {
        if (formatType) {
          prestador.nome_prestador = applyTextFormat(prestador.nome_prestador, formatType)
          prestador.especialidade = applyTextFormat(prestador.especialidade, formatType)
          prestador.endereco = applyTextFormat(prestador.endereco, formatType)
          prestador.bairro = applyTextFormat(prestador.bairro, formatType)
          prestador.complemento = applyTextFormat(prestador.complemento, formatType)
        }
      } catch (e) {
      }
      return prestador
    },
    async listaAcreditacoes () {
      const result = await this.apiFuncionalidade.listaAcreditacoes({
        payload: {},
        handlerErrorIgnore: [404]
      })
      return result.data
    },
    async getAcreditacoes (prestador) {
      const acreditacoesLegenda = await this.listaAcreditacoes()

      let acreditacoes = []
      if (prestador.acreditacoes) {
        let acred = {}
        const arrAcreditacoes = prestador.acreditacoes.split(',')

        if (Array.isArray(arrAcreditacoes)) {
          arrAcreditacoes.map((item) => {
            acred = acreditacoesLegenda.filter((value) => value.codigo === item.split(';')[1])
            acreditacoes.push(acred[0])
          })
        } else {
          acred = acreditacoesLegenda.filter((value) => value.codigo === prestador.acreditacoes.split(';')[1])
          acreditacoes.push(acred[0])
        }
      }
      return acreditacoes
    },
    openRoute () {
      const lat = this.prestador.latitude.replace(',', '.')
      const lng = this.prestador.longitude.replace(',', '.')
      const googleUrl = `https://google.com/maps/?q=${lat},${lng}`
      window.open(googleUrl)
    },
    async prestadorPlanos (prestador) {
      if (this.planos.length === 0) {
        this.loadingCollapseItem = true
        this.planos = []
        let planoOptions = []

        if (this.beneficiarios && this.beneficiarios.length > 0) {
          if (!this.funcParametros.usuarioLogadoVisualizaTodosPlanos) {
            let plano = ''
            this.beneficiarios.map((item) => {
              if (item.dadosDoPlano.idPlano !== plano) {
                planoOptions.push(item.dadosDoPlano.idPlano)
                plano = item.dadosDoPlano.idPlano
              }
            })
          }
        }

        const result = await this.apiFuncionalidade.detalhePrestadorPlanos({
          payload: {
            idOperadora: this.aplicacao.idOperadora,
            cpfCnpj: this.prestador.cpf_cnpj,
            prestadorSequencial: this.prestador.sequencial_endereco,
            planos: planoOptions
          },
          handlerErrorIgnore: [404]
        })
        if (!result.data || result.data.status === false) {
          this.loadingCollapseItem = false
          this.planos = []
          return false
        }

        this.planos = result.data
        this.loadingCollapseItem = false
      }
    },
    async prestadorHorariosAtendimento () {
      if (this.horariosAtendimento.length === 0) {
        this.loadingCollapseItem = true
        this.horariosAtendimento = []
        const result = await this.apiFuncionalidade.detalhePrestadorHorariosAtendimento({
          payload: {
            idOperadora: this.aplicacao.idOperadora,
            cpfCnpj: this.prestador.cpf_cnpj,
            prestadorSequencial: this.prestador.sequencial_endereco
          },
          handlerErrorIgnore: [404]
        })
        if (!result.data || result.data.status === false) {
          this.loadingCollapseItem = false
          this.horariosAtendimento = []
          return false
        }

        this.horariosAtendimento = result.data
        this.loadingCollapseItem = false
      }
    },
    async prestadorEquipeMedica () {
      if (this.equipeMedica.length === 0) {
        this.loadingCollapseItem = true
        this.equipeMedica = []
        const result = await this.apiFuncionalidade.detalhePrestadorCorpoClinico({
          payload: {
            idOperadora: this.aplicacao.idOperadora,
            cpfCnpj: this.prestador.cpf_cnpj,
            prestadorSequencial: this.prestador.sequencial_endereco
          },
          handlerErrorIgnore: [404]
        })
        if (!result.data || result.data.status === false) {
          this.loadingCollapseItem = false
          this.equipeMedica = []
          return false
        }
        this.equipeMedica = result.data
        this.loadingCollapseItem = false
      }
    },
    async prestadorEspecialidades () {
      if (this.especialidades.length === 0) {
        this.loadingCollapseItem = true
        this.especialidades = []
        const result = await this.apiFuncionalidade.detalhePrestadorEspecialidades({
          payload: {
            idOperadora: this.aplicacao.idOperadora,
            cpfCnpj: this.prestador.cpf_cnpj,
            prestadorSequencial: this.prestador.sequencial_endereco,
            idPlano: this.idPlano || '',
            tipoPrestador: this.prestador.id_tipo_prestador
          },
          handlerErrorIgnore: [404]
        })

        if (!result.data || result.data.status === false) {
          this.loadingCollapseItem = false
          this.especialidades = []
          return false
        }

        let descricao = ''
        await Promise.all(
          result.data.map((item) => {
            const esp = result.data.filter((value) => value.descricao === item.descricao)
            if (item.descricao !== descricao) {
              descricao = esp[0].descricao
              esp[0].descricao = applyTextFormat(esp[0].descricao, this.funcParametros.formatacaoTexto)
              this.especialidades.push(esp[0])
            }
          })
        )
        this.loadingCollapseItem = false
      }
    },
    async print () {
      this.loadingPrint = true

      try {
        await this.prestadorEspecialidades()
        await this.prestadorPlanos()
        await this.prestadorHorariosAtendimento()
        await this.prestadorEquipeMedica()
      } finally {
        this.loadingPrint = false
      }

      this.setPrestadorPlanos(this.planos)
      this.setPrestadorEspecialidades(this.especialidades)
      this.setPrestadorHorarios(this.horariosAtendimento)
      this.setPrestadorEquipeMedica(this.equipeMedica)

      this.setPrintType('detail')
      this.setViewPrint(true)
    },
    share () {
      this.showShare = true
    },
    async init () {
      this.loading = true
      const result = await detalheRedeCredenciada(
        this.aplicacao.idOperadora,
        this.prestador.id,
        this.funcParametros.agrupaEspecialidades
      )

      let prestador = this.formatTextosPrestador(result, this.funcParametros.formatacaoTexto)

      prestador.acreditacoes = await this.getAcreditacoes(prestador)

      if (prestador.latitude && prestador.longitude) {
        let latitude = parseFloat(prestador.latitude.replace(',', '.'))
        let longitude = parseFloat(prestador.longitude.replace(',', '.'))

        this.locations = [{
          coordenadas: [{ lat: latitude, long: longitude }],
          descricao: prestador.nome_prestador,
          endereco: prestador.endereco
        }]
        this.mapConfig.open = true
      }

      this.setPrestador(prestador)

      this.loading = false
    },
    async openCollapseItem (collapseItem) {
      switch (collapseItem) {
        case 'horariosAtendimento':
          await this.prestadorHorariosAtendimento()
          break
        case 'equipeMedica':
          await this.prestadorEquipeMedica()
          break
        case 'planosAtendidos':
          await this.prestadorPlanos()
          break
        case 'especialidades':
          await this.prestadorEspecialidades()
          break
      }
    },
    async openEspecialidades () {
      this.activeNames = !this.activeNames[0] ? ['especialidades'] : []
      this.tamanhoTextoEspecialidade(this.prestador.especialidade)
      if (this.activeNames.length) {
        await this.openCollapseItem('especialidades')
        this.especialidadesDefault = this.prestador.especialidade
        this.prestador.especialidade = this.especialidades.map(item => item.descricao).join(', ') + ' '
      } else {
        this.prestador.especialidade = this.especialidadesDefault
      }
    },
    tamanhoTextoEspecialidade (texto) {
      if (!this.especialidades.length) {
        const term = '[...]'
        this.especialidadesTextoGrande = texto.includes(term)
        return texto.replace(term, '...')
      }
      if (this.especialidadesDefault) {
        const term = '[...]'
        return texto.includes(term) ? texto.replace(term, '...') : texto
      }

      this.prestador.especialidade = texto

      return texto
    },
    tamanhoTextoSubespecialidade (texto) {
      const term = '[...]'
      return texto.includes(term) ? texto.replace(term, '...') : texto
    },
    ensureProtocol (url) {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        return `https://${url}`
      }
      return url
    },
    close () {
      this.$router.push({ path: `/4` })
      this.setViewDetalhe(false)
    }
  },
  async created () {
    if (this.$route.query.detalhe) {
      await this.init()
    }
  }
}

</script>

<style scoped>
.btn-detalhe-mapa {
  border-radius: 2px;
  border: none;
}

.item-button {
  color: var(--cor-primaria-aplicacao)
}

.icon-button-box-detalhe {
  border-right: 1px solid var(--cor-primaria-aplicacao-semi-transparent);
}

.icon-button-box-detalhe:last-child {
  border-right: none;
}

.button-icon {
  font-size: x-large;
  margin-bottom: 8px;
}

.button-icon-map {
  font-size: x-large;
}
</style>
